import { FormInitialValues, RadioGridFormField } from '@/forms/typings';
import { RadioGroup } from '../inputs';
import { Button } from '@/ui-kit';
import './RadioGridPresenter.scss';
import { useFormContext } from '../../core';
import { useCallback, useMemo } from 'react';
import { FormFieldAlertMessage } from './FormFieldAlertMessage';

type RadioGridPresenterProps = {
  field: RadioGridFormField;
};

export const RadioGridPresenter: React.FC<RadioGridPresenterProps> = ({
  field,
}) => {
  const { setValues, values } = useFormContext<FormInitialValues>();

  const authorizedValues = useMemo(() => {
    return field.columnToSelect !== undefined
      ? field.fields
          .map(group => group.fieldId)
          .reduce((acc, fieldId, index) => {
            const columnValue =
              field.fields[index].options?.[field.columnToSelect!].value;
            acc[fieldId] = columnValue;
            return acc;
          }, {} as FormInitialValues)
      : {};
  }, [field.fields, field.columnToSelect]);

  const handleAuthorizeAll = useCallback(() => {
    setValues({ ...values, ...authorizedValues });
  }, [authorizedValues, setValues, values]);

  return (
    <>
      {field.alertMessage && (
        <FormFieldAlertMessage alertMessage={field.alertMessage} />
      )}
      <div
        style={{ '--grid-columns': field.columnLabels.length }}
        className="radio-grid__container"
      >
        <div></div>
        {field.columnLabels.map((label, index) => (
          <label key={`${label}_${index}`} className="radio-grid__label">
            {label}
          </label>
        ))}
        {field.fields.map((group, index) => (
          <div key={`group_${index}`} className="radio-grid__group">
            <RadioGroup
              name={group.fieldId}
              label={group.label}
              options={group.options}
              orientation="row"
              boxedLayout={false}
              scale="large"
            />
          </div>
        ))}
        {field.columnToSelect !== undefined && (
          <Button
            className="radio-grid__button"
            variant="secondary"
            onClick={handleAuthorizeAll}
          >
            {field.selectAllButtonLabel ?? 'Authorize all'}
          </Button>
        )}
      </div>
    </>
  );
};
